import { Box } from '@mui/material';
import { AccountMenuButton } from './AccountMenuButton';
import { SponsorLogo } from './SponsorLogo';

/** Pre-enrollment top bar: the active brand's logo (when it has one) and the
 *  account menu — no client-side human-friendly study name exists to display
 *  (participation.name carries a technical identifier). */
export const PreEnrollmentTopBar = () => {
  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: { xs: 1.5, sm: 2 },
        minHeight: 62,
        px: { xs: 2, sm: 2.75 },
        py: 1,
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center' }}>
        <SponsorLogo />
      </Box>
      <AccountMenuButton />
    </Box>
  );
};
